/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Movement_Submit_DistributionInputs */



/**
* | output |
* | --- |
* | "Record distribution" |
*
* @param {Promo_Movement_Submit_DistributionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_movement_submit_distribution = /** @type {((inputs?: Promo_Movement_Submit_DistributionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Movement_Submit_DistributionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer la distribution")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar distribución")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar distribuição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra la distribuzione")
	return /** @type {LocalizedString} */ ("Record distribution")
});